import { FC } from 'react';
import styled from 'styled-components';

import { PagesToShow, ShowStrategy, DisplaySettings } from './components/display-rules';

type DisplayRulesProps = {};

export const DisplayRules: FC<DisplayRulesProps> = () => {
  return (
    <DisplayRulesWrapper>
      <DisplaySettings />
      <ShowStrategy />
      <PagesToShow />
    </DisplayRulesWrapper>
  );
};

const DisplayRulesWrapper = styled.div``;
